// extracted by mini-css-extract-plugin
module.exports = {"row":"valueRow_row__Hionp","noBorder":"valueRow_noBorder__3x4-p","noPaddingBottom":"valueRow_noPaddingBottom__3sfCQ","firstCell":"valueRow_firstCell__3lMgW"};